import { useSuggestionsShallowSelector } from 'components/WorkspaceEditor/SuggestionStore'
import { RefObject, useEffect } from 'react'

/**
 * Hook to reset scrollTop of a container div when requested via store.
 * Only resets if the default suggestion card filter is active.
 */
export const useResetScrollOnRequest = (
    containerRef: RefObject<HTMLDivElement>,
    isNotDefaultSuggestionCardFilter: boolean
) => {
    const {
        resetSuggestionScroll,
        setResetSuggestionScroll,
    } = useSuggestionsShallowSelector((state) => ({
        resetSuggestionScroll: state.resetSuggestionScroll,
        setResetSuggestionScroll: state.setResetSuggestionScroll,
    }))

    useEffect(() => {
        // Reset scroll only when requested, the container is available,
        // and the default suggestion card filter is active.
        if (
            !resetSuggestionScroll ||
            !containerRef.current ||
            isNotDefaultSuggestionCardFilter
        ) {
            return
        }
        containerRef.current.scrollTop = 0
        setResetSuggestionScroll(false)
    }, [
        resetSuggestionScroll,
        setResetSuggestionScroll,
        containerRef,
        isNotDefaultSuggestionCardFilter,
    ])
}
